

import Vue from "vue";
import AppCustomTable from "@/components/common/CustomTable.vue";

interface ICalculatorResult {
	formula: string;
	result: number;
}

export default Vue.extend({
	data() {
		return {
			results: [] as ICalculatorResult[],
			currentFormula: "",
			selectedFormula: null as ICalculatorResult | null
		};
	},
	props: {
		target: String,
		decimals: Number
	},
	methods: {
		validateFormula() {
			if(this.currentFormula==""){
				this.add();
				return;
			}
			try {
				if (!/^[\d+\-*/().\s]+$/.test(this.currentFormula)) {
					return;
				}
				const result = new Function(`return (${this.currentFormula})`)();
				if (isNaN(result) || !isFinite(result)) {
					return;
				}
				this.results.push({formula: this.currentFormula, result});
				this.selectedFormula = this.results[this.results.length - 1];
				this.currentFormula = "";
			} catch (e) {
				return null;
			}
		},
		cancel(){
			this.$emit("cancel");
		},
		add(){
			if(this.currentFormula!=""){
				this.validateFormula();
			}

			let result = this.selectedFormula?.result;
			if (typeof result === "number" && typeof this.decimals === "number") {
				result = parseFloat(result.toFixed(this.decimals));
			}
			this.$emit("input",result);
			this.$emit("cancel");
		}
	},
	components: {
		AppCustomTable
	},
	i18nEx: {
		componentPrefix: "components.Calculator"
	}
});


